export default __webpack_public_path__ + "static/akitabox_b.dc28bb838eccc941d9b92ceaf501ec3e.png";